import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

import { UserOutline, CalendarOutline, SearchOutline } from 'antd-mobile-icons'

import { getLoginInfo } from '../../utils/storage/tour'

import './index.less'

class NavigationBar extends Component {
    render() {
        const { current = 0, callback } = this.props

        const loginInfo = getLoginInfo() || {}
        const { member, token } = loginInfo
        return (
            <div style={{ height: 48 }}>
                <div className='nav-bar jm-flex'>
                    <div
                        onClick={() => {
                            if (current !== 0) {
                                this.props.history.push('/home', { from: window.location.hash })
                            } else {
                                callback && setTimeout(() => callback(), 100)
                            }

                        }}
                        className={`jm-flex-item nav-item ${current === 0 ? 'current' : ''}`}>
                        <div><SearchOutline fontSize={23} /></div>
                        <div className='fs-12'>Home</div>

                    </div>
                    <div
                        onClick={() => {
                            if (current !== 1) {
                                this.goToView('/bookings', token, '?click=1')
                                // if (token && token.access_token) {
                                //     this.props.history.push('/bookings', { from: window.location.hash })
                                // } else {
                                //     this.props.history.push('/login', { from: window.location.hash })
                                // }

                            }

                        }}
                        className={`jm-flex-item nav-item ${current === 1 ? 'current' : ''}`}>
                        <div><CalendarOutline fontSize={23} /></div>
                        <div className='fs-12'>Bookings</div>

                    </div>
                    <div
                        onClick={() => current !== 2 && this.goToView('/profile', token)}
                        className={`jm-flex-item nav-item ${current === 2 ? 'current' : ''}`}>
                        <div><UserOutline fontSize={23} /></div>
                        <div className='fs-12'>My</div>

                    </div>
                </div>
            </div>
        )
    }

    goToView = (view, token, search) => {

        if (token && token.access_token) {
            this.props.history.push({ pathname: view, state: { from: window.location.hash }, search })
        } else {
            this.props.history.push({ pathname: '/login', state: { from: window.location.hash }, search })
        }
    }
}

export default withRouter(NavigationBar)
